import { Provider } from "../../models/provider/provider.model";
import { ProviderProfile } from "../../models/provider/provider-profile.model";

export interface IProviderState {
    providerGuid: string | null;
    provider: Provider | null;
    providerProfile: ProviderProfile | null;
    loading: boolean;
    saving: boolean;
    deleting: boolean;
    error: string | null;
}

export const initialProviderState: IProviderState = {
    providerGuid: null,
    provider: null,
    providerProfile: null,
    loading: false,
    saving: false,
    deleting: false,
    error: null
};
